var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContaEscuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 116,
    viewBox: "0 0 98 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0714 17.5C54.0714 27.165 46.2044 35 36.5 35C26.7956 35 18.9286 27.165 18.9286 17.5C18.9286 7.83502 26.7956 0 36.5 0C46.2044 0 54.0714 7.83502 54.0714 17.5Z",
    fill: "url(#paint0_radial_1002_1810)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8929 135.625C40.8929 138.041 38.9261 140 36.5 140C34.0739 140 32.1071 138.041 32.1071 135.625C32.1071 133.209 34.0739 131.25 36.5 131.25C38.9261 131.25 40.8929 133.209 40.8929 135.625Z",
    fill: "url(#paint1_radial_1002_1810)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1994 74.7136C42.2383 75.5019 45.2857 79.0465 45.2857 83.3C45.2857 86.3809 43.6869 89.0899 41.2706 90.6489L30.8963 99.8913C32.6562 100.481 34.5407 100.8 36.5 100.8C46.2044 100.8 54.0714 92.965 54.0714 83.3C54.0714 76.8744 50.5941 71.2576 45.4115 68.2143L38.1994 74.7136Z",
    fill: "url(#paint2_radial_1002_1810)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9603 66.6614C40.2416 66.1023 38.4062 65.8 36.5 65.8C26.7956 65.8 18.9286 73.635 18.9286 83.3C18.9286 89.7775 22.4622 95.4331 27.7144 98.4589L34.9725 91.9182C30.8484 91.1982 27.7143 87.6136 27.7143 83.3C27.7143 80.1677 29.3669 77.4198 31.8511 75.8739L41.9603 66.6614Z",
    fill: "url(#paint3_radial_1002_1810)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7143 109.655C42.4946 110.633 45.2857 114.054 45.2857 118.125C45.2857 122.957 41.3522 126.875 36.5 126.875C31.6478 126.875 27.7143 122.957 27.7143 118.125C27.7143 115.32 29.0398 112.823 31.1012 111.221L41.9748 101.666C40.2519 101.104 38.4116 100.8 36.5 100.8C26.7956 100.8 18.9286 108.635 18.9286 118.3C18.9286 127.965 26.7956 135.8 36.5 135.8C46.2044 135.8 54.0714 127.965 54.0714 118.3C54.0714 111.987 50.7148 106.454 45.6819 103.376L38.7143 109.655Z",
    fill: "url(#paint4_radial_1002_1810)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1429 52.5C10.1429 62.165 2.27586 70 -7.42857 70C-17.133 70 -25 62.165 -25 52.5C-25 42.835 -17.133 35 -7.42857 35C2.27586 35 10.1429 42.835 10.1429 52.5Z",
    fill: "url(#paint5_radial_1002_1810)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52.5C98 62.165 90.133 70 80.4286 70C70.7241 70 62.8571 62.165 62.8571 52.5C62.8571 42.835 70.7241 35 80.4286 35C90.133 35 98 42.835 98 52.5Z",
    fill: "url(#paint6_radial_1002_1810)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.45428 49.7921L74.4543 47.6905V68.95C44.8655 58.2392 28.1713 58.2045 -1.45428 68.95V49.7921Z",
    fill: "url(#paint7_radial_1002_1810)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3472 54.3187H-1.45396V36.05C28.1344 46.762 44.8286 46.7973 74.4546 36.0531L73.3472 54.3187Z",
    fill: "url(#paint8_radial_1002_1810)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7443 107.665C24.1305 105.07 38.1667 93.1925 43.1162 89.0078C48.0658 84.823 55.5745 88.8811 48.719 95.6875C41.8635 102.494 32.6173 109.914 29.5376 112.807C26.458 115.7 21.3582 110.259 22.7443 107.665Z",
    fill: "url(#paint9_radial_1002_1810)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5426 71.3594L42.7497 54.0507L48.7456 60.6502L29.4714 77.9625L23.5426 71.3594Z",
    fill: "url(#paint10_radial_1002_1810)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2946 129.037C49.783 130.392 39.8926 138.706 38.6335 139.437C37.3744 140.168 35.7408 134.801 35.7408 134.801L47.3335 125.779C47.3335 125.779 50.8061 127.681 50.2946 129.037Z",
    fill: "url(#paint11_radial_1002_1810)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7857 139.578C33.1246 139.444 23.6951 130.6 22.9098 129.359C22.1245 128.119 29.1081 124.297 29.1081 124.297L39.2448 134.917C39.2448 134.917 36.4468 139.711 34.7857 139.578Z",
    fill: "url(#paint12_radial_1002_1810)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1002_1810",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4762 74.4444) rotate(90) scale(60 53.3222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1428A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContaEscuro);
export default __webpack_public_path__ + "static/media/contaEscuro.dc161708c7ce1974dbd3eed7cdd5dfcd.svg";
export { ForwardRef as ReactComponent };